
let key = "lastSection";
export function getLastSection() {
    let lastSection = localStorage.getItem(key);
    return JSON.parse(lastSection)
}
export function updateSection(lastSection) {
    localStorage.setItem(key, JSON.stringify(lastSection))
}
